import { useEffect, useState } from "react";
import useRequestUrl from "../../../hooks/useRequestUrl";
import { useAxiosPrivate } from "../../../hooks/useAxiosPrivate";
import { useAlertStore } from "../../../store/alert-store";
import { useExceptionHandler } from "../../../hooks/useExceptionHandler";

const useLlmWhipererAdapterSchema = () => {
  const { getUrl } = useRequestUrl();
  const axiosPrivate = useAxiosPrivate();
  const { setAlertDetails } = useAlertStore();
  const handleException = useExceptionHandler();

  const [llmWAdapterUrl, setLlmWAdapterUrl] = useState(null);
  const [defaultLlmWAdapterUrl, setDefaultLlmWAdapterUrl] = useState(null);

  useEffect(() => {
    const fetchLlmWAdapterUrl = async () => {
      const requestOptions = {
        method: "GET",
        url: getUrl("/unstract-llmw-adapter-url/"),
      };

      try {
        const res = await axiosPrivate(requestOptions);
        const url = res?.data?.url || null;
        setLlmWAdapterUrl(url);
      } catch (err) {
        setLlmWAdapterUrl(null);
        setAlertDetails(handleException(err));
      }
    };

    fetchLlmWAdapterUrl();
  }, []);

  const transformLlmWhispererFormData = (formData) => {
    if (!llmWAdapterUrl || !Object.keys(formData || {})?.length) {
      return formData;
    }

    if (
      formData?.use_platform_provided_unstract_key &&
      formData?.url !== llmWAdapterUrl
    ) {
      setDefaultLlmWAdapterUrl(formData?.url);
      return { ...formData, url: llmWAdapterUrl };
    }

    if (
      !formData?.use_platform_provided_unstract_key &&
      formData?.url === llmWAdapterUrl &&
      defaultLlmWAdapterUrl
    ) {
      return { ...formData, url: defaultLlmWAdapterUrl };
    }

    return formData;
  };

  return { transformLlmWhispererFormData };
};

export { useLlmWhipererAdapterSchema };
